import "flatpickr/dist/themes/material_blue.css";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import {
  GET_ROLE_DATA,
  SAVE_ROLE,
  DELETE_ROLE,
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Form,
  FormGroup,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Modal,
  Row,
  Badge,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,

} from "reactstrap";

import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import "../../../assets/scss/datatables.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import classnames from "classnames"
import FlowSelection from "pages/FlowSelection";

function RoleDetail(props) {

  const dispatch = useDispatch();

  let history = useHistory();
  let { pid } = useParams();

  const searchObj = { PID: pid, };
  const createObj = {
    PID: "",
    ROLE_NAME: "",
    ROLE_DESC: "",

    //Menu Dashboard
    DHME: false, DBUI: false, DBIA: false,

    //Menu Input Management
    vBKD: false, eBKD: false, vNMW: false, eNMW: false, vNMD: false, eNMD: false, vMTD: false, eMTD: false, vALD: false, eALD: false, vMTM: false, eMTM: false, vQPD: false, eQPD: false,

    //Menu FlowSelection
    vFSN: false, eFSN: false,

    //Menu Flow Logic
    vFLC: false, eFLC: false,

    //Menu Manual Data Entry
    vGLP: false, eGLP: false, vFFO: false, eFFO: false, vBSG: false, eBSG: false, vDFO: false, eDFO: false, vGAC: false, eGAC: false, vOTH: false, eOTH: false,

    //Menu Alarm Management
    vALM: false, eALM: false,

    //Menu Summary report
    vSRT: false, eSRT: false,

    //Menu Report
    vTPA: false, eTPA: false,
    vEOD: false, eEOD: false,
    // vOBR: false, eOBR: false,
    vTBR: false, eTBR: false,
    // vTCR: false, eTCR: false, 
    vPUR: false, ePUR: false,
    vAGD: false, eAGD: false,
    vGDP: false, eGDP: false,
    vDGF: false, eDGF: false,
    vSTR: false, eSTR: false,
    vASD: false, eASD: false,
    vGCN: false, eGCN: false,
    // vERD: false, eERD: false,
    // vRFN: false, eRFN: false,
    // vCFE: false, eCFE: false,

    //Menu User Management
    vRMN: false, eRMN: false, vUSM: false, eUSM: false, vEMP: false, eEMP: false, //vRFD: false, eRFD: false,

    //Menu Master Data Setting
    vSHP: false, eSHP: false, vMET: false, eMET: false, vOTR: false, eOTR: false, vVMT: false, eVMT: false,

    //Menu Dashboard URL
    vDUL: false, eDUL: false,

    //Menu API System Config
    vAPI: false, eAPI: false, vAPP: false, eAPP: false,   //vDSC: false, eDSC: false, 

    //Menu Report Viewer
    vRVB: false, vRVN: false, vRVA: false, vRVM: false,

    //Edit Button In SummaryReport And ManualDataEntry
    mRFM: false, mMIM: false,

  };
  const pidInfoCustomer = { PID: pid };

  // const customerData = {personShipper:""};
  const [activeTab, setActiveTab] = useState("1");
  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [userActionType, setUserActionType] = useState("");
  const [dataCustomer, setDataCustomer] = useState({});
  const [dataRole, setDataRole] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();
  const confirmSetMainContact = useConfirmDialog();
  const [selectedData, setSelectedData] = useState({});

  // const listMainTabGroup = [{ TabDashboard: { HeadSubMenu: {}, Submenu: {} }, }, { TabOperation: "" }, { TabAnalysisReport: "" }, { TabConfiguration: "" }
  // TabDashboard: listMenuDashboard, 
  // TabOperation: listMenuOperation, 
  // TabAnalysisReport: listMenuAnalysis, 
  // TabConfiguration: listMenuConfig
  // }
  // ];

  // console.log(listMainTabGroup);
  // const listMenuDashboard = [{MainSubMenu : "Dashboard" , Submenu: listSubMenuDashboard}]
  // const listSubMenuDashboard = [];


  const backToMainPage = () => {
    history.push("/role-management");
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  const SelectMainContact = (cellContent, row) => {
    // console.log(row)
    let color;
    let label;

    if (row.PRIORITY_FLAG == 1) {
      color = "success";
      label = "Main Contact";
    } else {
      color = "warning";
      label = "Switch to main contact";
    }
    return (
      <div className="justify-content-between">
        <Badge
          onClick={() => {
            if (row.PRIORITY_FLAG != 1) {
              setSelectedData(row);
              confirmSetMainContact.toggleConfirm("Do you want to confirm a main contact ?");
            }
          }}
          className={"font-size-12 badge-soft-" + color}
          color="danger"
          pill
        >
          {label}
        </Badge>
      </div >
    );
  };

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row);
    return (
      <div>
        {/* {row.PRIORITY_FLAG != 1 &&
          <Button
            className="me-1 mt-1"
            onClick={() => {
              setSelectedData(row);
              confirmSetMainContact.toggleConfirm("Do you want to confirm main contact ?");
            }}
            color="info"
          > Set to main contact </Button>
        } */}

        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        <OverButton
          onClick={() => {
            setReadonly(false);
            onEdit(row);
            setUserActionType("(Edit)");
          }}
          color="info"
          icon="far fa-edit"
          label="Edit"
        />

        {/* <OverButton onClick={() => { setModalPerson(true) }} color="secondary" icon="fas fa-users" label="Person" /> */}
        <OverButton
          onClick={() => {
            onDelete(row);
          }}
          color="danger"
          icon="fas fa-trash-alt"
          label="Delete"
        />
      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };
  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      formatter: CountIndexRow,
    },
    {
      dataField: "ALIAS_NAME",
      text: "Contact Name",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "EMAIL",
      text: "E-mail",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "TEL",
      text: "Tel",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "Main Contact",
      formatter: SelectMainContact,
      text: "Main Contact",
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      align: "center",
      isDummyField: true,
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);

    // let tableId = "role-table";
    // let scrollY = 287;
    // function fixedTableHeader() {
    //   let headerTable = document.querySelector(`#${tableId} thead`);
    //   if (window.scrollY >= scrollY) {
    //     headerTable.classList.add("fixed-header");
    //     resizeTableHeader();
    //   } else {
    //     headerTable?.classList.remove("fixed-header");
    //   }
    // }
    // function resizeTableHeader() {
    //   setTimeout(() => {
    //     let headerTable = document.querySelector(`#${tableId} thead`);
    //     let tr = document.querySelector(`#${tableId} tbody tr`);
    //     let th = headerTable.querySelector("tr");
    //     // console.log(th);
    //     if (tr) {
    //       for (var i = 0; i < tr.childNodes.length; i++) {
    //         th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
    //         // console.log(tr.childNodes[i].offsetWidth);
    //       }
    //     }
    //   }, 1);
    // }
    // window.addEventListener("scroll", fixedTableHeader);
    // document
    //   .querySelector(`#vertical-menu-btn`)
    //   .addEventListener("click", resizeTableHeader);
    // return () => {
    //   window.removeEventListener("scroll", fixedTableHeader);
    //   document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    // };
  }, []);
  //onInit//

  // useEffect(function () {
  //   console.log(dataRole);
  //   if (dataRole.listAuth) {
  //     console.log({
  //       ...dataRole, listAuth: dataRole.listAuth.map((item) => {
  //         if (item.name == 'DHME') {
  //           item.access = true;
  //         }
  //         return item
  //       })
  //     });
  //   }
  //   if (dataRole.listAuth) {
  //     console.log(dataRole.listAuth.find(item => item.name == 'DHME').access)
  //   }
  // }, [dataRole])

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    // getInformationCustomer(pidInfoCustomer);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {

    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }

    if (createModel.EMAIL == "") {
      bResult = false;
    }

    if (createModel.TEL == "") {
      bResult = false;
    }
    return bResult;
  };

  const fetchData = async (pid) => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ROLE_DATA, pid);
      setDataRole(res.data.roleList[0]);
      // setModelDeviceList(res.data.roleList);
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // useEffect(function () {
  //   console.log(dataRole.listAuth);
  // }, [dataRole]);

  const saveData = async () => {

    // if (validateForm()) {
    dispatch(loadingAction.showLoading());
    // console.log(dataRole);
    try {
      let res = await post(SAVE_ROLE, dataRole);
      // console.log(res);
      if (res.resultCode == 200) {
        let Mes = res.isEditMode == 0 ? "Save success." : "Update success.";
        dispatch(messageAction.showMessage(Mes));
        fetchData(searchModel);
        backToMainPage();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    dispatch(loadingAction.hideLoading());

    // }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_ROLE, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.message);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  //Function CURL


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {dataRole.listAuth && (
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                      <h1 className="mb-sm-0 font-size-20">
                        {" "}
                        {props.t("Role Management Detail")}
                        {/* {dataCustomer.FULL_NAME} */}
                      </h1>
                      <div className="page-title-right">
                        <ol className="breadcrumb m-0">
                          <li className="breadcrumb-item">
                            <Link to="#" style={{ color: "#556ee6" }}>
                              User Management
                            </Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/role-management" style={{ color: "#556ee6" }}>
                              Role Management
                            </Link>
                          </li>
                          <li className="breadcrumb-item active">Role Management Detail</li>
                        </ol>
                      </div>
                    </div>
                    <hr />

                    <Row>
                      <Col sm="12">

                        <FormGroup className="row mt-2">
                          <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end">
                            Role Name
                          </Label>
                          <Col sm={3}>
                            <div className="position-relative">
                              <Input
                                // style={{ border: "solid 1px #FFFFFF" }}
                                // disabled
                                type="text"
                                // disabled={readonly}
                                className="form-control basicborder"
                                onChange={e =>
                                  setDataRole({
                                    ...dataRole,
                                    ROLE_NAME: e.target.value,
                                  })
                                }
                                value={dataRole.ROLE_NAME}
                              />
                            </div>
                          </Col>
                          <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end">
                            Description
                          </Label>
                          <Col sm={4}>
                            <div className="position-relative">
                              <Input
                                // style={{ border: "solid 1px #FFFFFF" }}
                                type="text"
                                // disabled={readonly}
                                className="form-control basicborder"
                                onChange={e =>
                                  setDataRole({
                                    ...dataRole,
                                    ROLE_DESC: e.target.value,
                                  })
                                }
                                value={dataRole.ROLE_DESC}
                              />
                            </div>
                          </Col>
                        </FormGroup>

                      </Col>
                    </Row>

                    <Row className="mb-0 mt-4">
                      <Col lg={8}>
                        <Nav pills className="navtab-bg nav-justified">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Dashboard
                              {/* <span className="d-none d-sm-block"><i className="fas fa-home"></i> Home</span>
                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span> */}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                setActiveTab("2");
                              }}
                            >
                              Operation
                              {/* <span className="d-none d-sm-block"><i className="fas fa-user"></i> Profile</span>
                            <span className="d-block d-sm-none"><i className="fas fa-user"></i></span> */}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                setActiveTab("3");
                              }}
                            >
                              Analysis Report
                              {/* <span className="d-none d-sm-block"><i className="fab fa-facebook-messenger"></i> Messages</span>
                            <span className="d-block d-sm-none"><i className="fab fa-facebook-messenger"></i></span> */}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "4",
                              })}
                              onClick={() => {
                                setActiveTab("4");
                              }}
                            >
                              Configuration
                              {/* <span className="d-none d-sm-block"><i className="fas fa-cog"></i> Settings</span>
                            <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span> */}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "5",
                              })}
                              onClick={() => {
                                setActiveTab("5");
                              }}
                            >
                              Report Viewer
                              {/* <span className="d-none d-sm-block"><i className="fas fa-cog"></i> Settings</span>
                            <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span> */}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                    </Row>

                    <Row>
                      <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                      >
                        <TabPane tabId="1">
                          <Row>
                            <Col sm="12">
                              <div className="table-responsive">
                                {/* hover-table-highlight */}
                                <Table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      {/* <th>#</th> */}
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "60%" }}>Item</th>
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>View</th>
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody className="td-style" style={{ color: "#FFFFFF" }} >
                                    <tr>
                                      <td>Dashboard</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Daily Dashboard</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          disabled
                                          checked={dataRole.listAuth.find(item => item.name == 'DHME').access}
                                          id="DHME"
                                          onChange={e => {
                                            // setDataRole({
                                            //   ...dataRole.listAuth.map(item => item.name == 'DHME'),
                                            //   access: e.target.checked,
                                            // })
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'DHME') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BI Dashboard</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'DBUI').access}
                                          id="DBUI"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'DBUI') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BI Dashboard ( Admin ) </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'DBIA').access}
                                          id="DBIA"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'DBIA') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>

                            </Col>
                          </Row>
                        </TabPane>

                        <TabPane tabId="2">
                          <Row>
                            <Col sm="12">
                              <div className="table-responsive">
                                {/* hover-table-highlight */}
                                {/* id="role-table"  */}
                                <Table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      {/* <th>#</th> */}
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "60%" }}>Item</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>View</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody style={{ color: "#FFFFFF" }}>
                                    <tr>
                                      <td>Input Management</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Booking Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vBKD').access}
                                          id="vBKD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vBKD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eBKD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eBKD').access}
                                          id="eBKD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eBKD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vBKD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nomination Week</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vNMW').access}
                                          id="vNMW"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vNMW') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eNMW') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eNMW').access}
                                          id="eNMW"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eNMW') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vNMW') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nomination Day</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vNMD').access}
                                          id="vNMD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vNMD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eNMD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eNMD').access}
                                          id="eNMD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eNMD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vNMD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Metering ( Daily )</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vMTD').access}
                                          id="vMTD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vMTD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eMTD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eMTD').access}
                                          id="eMTD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eMTD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vMTD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Allocation Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vALD').access}
                                          id="vALD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vALD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eALD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eALD').access}
                                        id="eALD"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eALD') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vALD') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Metering ( Monthly )</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vMTM').access}
                                          id="vMTM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vMTM') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eMTM') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eMTM').access}
                                          id="eMTM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eMTM') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vMTM') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quality Point Daily ( GC Name )</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vQPD').access}
                                          id="vQPD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vQPD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eQPD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eQPD').access}
                                          id="eQPD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eQPD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vQPD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Flow / HV / Energy Selection</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vFSN').access}
                                          id="vFSN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vFSN') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eFSN') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eFSN').access}
                                        id="eFSN"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eFSN') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vFSN') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    {/* <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flow Selection</td>
                                    </tr> */}


                                    <tr>
                                      <td>Manual Data Entry</td>
                                      <td></td>
                                      <td></td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Manage Input Formula Management</td>
                                      <td></td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'mMIM').access}
                                          id="mMIM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'mMIM') {
                                                  item.access = e.target.checked;
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gas Volumn Line Pack</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vGLP').access}
                                          id="vGLP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vGLP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eGLP') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eGLP').access}
                                        id="eGLP"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eGLP') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vGLP') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flow/Fuel Oil ( Monthly & Daily )</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vFFO').access}
                                          id="vFFO"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vFFO') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eFFO') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eFFO').access}
                                          id="eFFO"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eFFO') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vFFO') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Balancing & Shrinkage Gas Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vBSG').access}
                                          id="vBSG"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vBSG') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eBSG') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eBSG').access}
                                        id="eBSG"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eBSG') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vBSG') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Diesel & Fuel Oil Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vDFO').access}
                                          id="vDFO"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vDFO') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eDFO') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eDFO').access}
                                        id="eDFO"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eDFO') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vDFO') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Other Key-in Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vOTH').access}
                                          id="vOTH"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vOTH') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eOTH') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eOTH').access}
                                        id="eOTH"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eOTH') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vOTH') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gas Composition</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vGAC').access}
                                          id="vGAC"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vGAC') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eGAC') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eGAC').access}
                                        id="eGAC"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eGAC') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vGAC') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Alarm Management</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vALM').access}
                                          id="vALM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vALM') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eALM') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eALM').access}
                                        id="eALM"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eALM') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vALM') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                  </tbody>
                                </Table>
                              </div>
                            </Col>

                          </Row>
                        </TabPane>

                        <TabPane tabId="3">
                          <Row>
                            <Col sm="12">
                              <div className="table-responsive">
                                {/* hover-table-highlight */}
                                <Table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      {/* <th>#</th> */}
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "60%" }}>Item</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>View</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody style={{ color: "#FFFFFF" }}>
                                    <tr>
                                      <td>Summary Report</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Summary Report</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vSRT').access}
                                          id="vSRT"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vSRT') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eSRT') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eSRT').access}
                                          id="eSRT"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eSRT') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vSRT') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Report Formula Management</td>
                                      <td></td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'mRFM').access}
                                          id="mRFM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'mRFM') {
                                                  item.access = e.target.checked;
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Report</td>
                                      <td></td>
                                      <td></td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TPA Daily</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vTPA').access}
                                          id="vTPA"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vTPA') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eTPA') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eTPA').access}
                                          id="eTPA"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eTPA') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vTPA') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>


                                    {/* <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Offshore Balancing Report</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vOBR}
                                        id="vOBR"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vOBR: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eOBR}
                                        id="eOBR"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eOBR: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TPA Balancing & Overuse </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vTBR').access}
                                          id="vTBR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vTBR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eTBR') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eTBR').access}
                                          id="eTBR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eTBR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vTBR') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    {/* <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TPA Capacity Overuse Report</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vTCR}
                                        id="vTCR"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vTCR: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eTCR}
                                        id="eTCR"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eTCR: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pipeline Utilization</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vPUR').access}
                                          id="vPUR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vPUR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'ePUR') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'ePUR').access}
                                          id="ePUR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'ePUR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vPUR') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Average Gas Delivery</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vAGD').access}
                                          id="vAGD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vAGD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eAGD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eAGD').access}
                                          id="eAGD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eAGD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vAGD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gas Delivery Performance</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vGDP').access}
                                          id="vGDP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vGDP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eGDP') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eGDP').access}
                                          id="eGDP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eGDP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vGDP') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delivery Gas/Fuel Gas</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vDGF').access}
                                          id="vDGF"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vDGF') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eDGF') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eDGF').access}
                                          id="eDGF"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eDGF') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vDGF') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Shift </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vSTR').access}
                                          id="vSTR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vSTR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eSTR') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eSTR').access}
                                          id="eSTR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eSTR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vSTR') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>


                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Actual Supply Demand ( Actual GSM )</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vASD').access}
                                          id="vASD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vASD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eASD') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eASD').access}
                                          id="eASD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eASD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vASD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gas Composition</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vGCN').access}
                                          id="vGCN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vGCN') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eGCN') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eGCN').access}
                                          id="eGCN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eGCN') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vGCN') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    {/* <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Export Raw Data</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vERD}
                                        id="vERD"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vERD: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eERD}
                                        id="eERD"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eERD: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                    {/* 
                                  <tr>
                                    <td>Report Formation</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vRFN}
                                        id="vRFN"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vRFN: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eRFN}
                                        id="eRFN"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eRFN: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>

                        <TabPane tabId="4">
                          <Row>
                            <Col sm="12">
                              <div className="table-responsive">
                                {/* hover-table-highlight */}
                                <Table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      {/* <th>#</th> */}
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "60%" }}>Item</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>View</th>
                                      <th style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody style={{ color: "#FFFFFF" }}>
                                    {/* <tr>
                                    <td>Criteria & Formular Editing</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vCFE}
                                        id="vCFE"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vCFE: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eCFE}
                                        id="eCFE"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eCFE: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                    <tr>
                                      <td>User Management</td>
                                      <td></td>
                                      <td></td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;User Management</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vUSM').access}
                                          id="vUSM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vUSM') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eUSM') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eUSM').access}
                                          id="eUSM"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eUSM') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vUSM') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Role Management</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vRMN').access}
                                          id="vRMN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vRMN') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eRMN') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eRMN').access}
                                          id="eRMN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eRMN') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vRMN') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;E-mail Management</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vEMP').access}
                                          id="vEMP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vEMP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eEMP') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eEMP').access}
                                          id="eEMP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eEMP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vEMP') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    {/* <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Refresh data from PIS</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vRFD}
                                        id="vRFD"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vRFD: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eRFD}
                                        id="eRFD"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eRFD: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                    <tr>
                                      <td>Master Data Setting</td>
                                      <td></td>
                                      <td></td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Shipper</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vSHP').access}
                                          id="vSHP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vSHP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eSHP') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eSHP').access}
                                          id="eSHP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eSHP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vSHP') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Meter</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vMET').access}
                                          id="vMET"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vMET') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eMET') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eMET').access}
                                          id="eMET"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eMET') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vMET') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Virtual Meter</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vVMT').access}
                                          id="vVMT"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vVMT') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eVMT') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eVMT').access}
                                          id="eVMT"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eVMT') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vVMT') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flow Logic</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vFLC').access}
                                          id="vFLC"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vFLC') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eFLC') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}> <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={dataRole.listAuth.find(item => item.name == 'eFLC').access}
                                        id="eFLC"
                                        onChange={e => {
                                          setDataRole({
                                            ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                              if (item.name == 'eFLC') {
                                                item.access = e.target.checked;
                                              }
                                              if (e.target.checked == true) {
                                                if (item.name == 'vFLC') {
                                                  item.access = true;
                                                }
                                              }
                                              return item
                                            })
                                          });
                                        }}
                                      />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Other</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vOTR').access}
                                          id="vOTR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vOTR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eOTR') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eOTR').access}
                                          id="eOTR"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eOTR') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vOTR') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Dashboard URL</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vDUL').access}
                                          id="vDUL"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vDUL') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eDUL') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eDUL').access}
                                          id="eDUL"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eDUL') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vDUL') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>System Config</td>
                                      <td></td>
                                      <td></td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;API Schedule Run</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vAPI').access}
                                          id="vAPI"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vAPI') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eAPI') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eAPI').access}
                                          id="eAPI"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eAPI') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vAPI') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;API PMIS Parameter</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vAPP').access}
                                          id="vAPP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vAPP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == false) {
                                                  if (item.name == 'eAPP') {
                                                    item.access = false;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eAPP').access}
                                          id="eAPP"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eAPP') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vAPP') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                    </tr>


                                    {/* <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data Source Connection</td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.vDSC}
                                        id="vDSC"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            vDSC: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={createModel.eDSC}
                                        id="eDSC"
                                        onChange={e => {
                                          setCreateModel({
                                            ...createModel,
                                            eDSC: e.target.checked,
                                          })
                                        }}
                                      />
                                    </td>
                                  </tr> */}

                                  </tbody>
                                </Table>
                              </div>

                            </Col>
                          </Row>
                        </TabPane>

                        <TabPane tabId="5">
                          <Row>
                            <Col sm="12">
                              <div className="table-responsive">
                                {/* hover-table-highlight */}
                                <Table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      {/* <th>#</th> */}
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "60%" }}>Item</th>
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>View</th>
                                      <th className="header-style" style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", width: "20%" }}>Edit</th>
                                    </tr>
                                  </thead>
                                  <tbody className="td-style" style={{ color: "#FFFFFF" }} >
                                    <tr>
                                      <td>Report Viewer</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Booking Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          // disabled
                                          checked={dataRole.listAuth.find(item => item.name == 'vRVB').access}
                                          id="vRVB"
                                          onChange={e => {
                                            // setDataRole({
                                            //   ...dataRole.listAuth.map(item => item.name == 'DHME'),
                                            //   access: e.target.checked,
                                            // })
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vRVB') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nomination Day</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vRVN').access}
                                          id="vRVN"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vRVN') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Metering Data ( Monthly ) </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          // disabled
                                          checked={dataRole.listAuth.find(item => item.name == 'vRVM').access}
                                          id="vRVM"
                                          onChange={e => {
                                            // setDataRole({
                                            //   ...dataRole.listAuth.map(item => item.name == 'DHME'),
                                            //   access: e.target.checked,
                                            // })
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vRVM') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Allocation Data</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vRVA').access}
                                          id="vRVA"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vRVA') {
                                                  item.access = e.target.checked;
                                                }
                                                // console.log(item);
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EOD Summary</td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'vEOD').access}
                                          id="vEOD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'vEOD') {
                                                  item.access = e.target.checked;
                                                }
                                                // if (e.target.checked == false) {
                                                //   if (item.name == 'eEOD') {
                                                //     item.access = false;
                                                //   }
                                                // }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td>
                                      {/* <td style={{ textAlign: "center" }}>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={dataRole.listAuth.find(item => item.name == 'eEOD').access}
                                          id="eEOD"
                                          onChange={e => {
                                            setDataRole({
                                              ...dataRole, listAuth: dataRole.listAuth.map((item) => {
                                                if (item.name == 'eEOD') {
                                                  item.access = e.target.checked;
                                                }
                                                if (e.target.checked == true) {
                                                  if (item.name == 'vEOD') {
                                                    item.access = true;
                                                  }
                                                }
                                                return item
                                              })
                                            });
                                          }}
                                        />
                                      </td> */}
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>

                            </Col>
                          </Row>
                        </TabPane>


                      </TabContent>
                    </Row>

                    <Row>
                      <div className="text-center mt-2">

                        <button
                          type="submit"
                          className="btn btn-success me-2"
                          onClick={() => saveData()}
                        >
                          <i className="far fa-save"></i> Save
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => backToMainPage()}
                        >
                          <i className="fas fa-times"></i> Cancel
                        </button>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>


      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />

      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />


    </React.Fragment >
  );
}

RoleDetail.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ RoleDetail }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RoleDetail));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
